import { render, staticRenderFns } from "./UpdatePaymentBtn.vue?vue&type=template&id=9b4b024c"
import script from "./UpdatePaymentBtn.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports